import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ItemAttributeSetLinkContainerModel } from '../../../../../../models/aggregates/erp/attribute/item-attribute-set-link-container.model';
import { ApiVisa } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class ItemAttributeSetLinkService extends BaseApiTemplateService<ItemAttributeSetLinkContainerModel> {
  // https://api-test.akaun.com/core2/tnt/dm/erp/attribute/item-attribute-set-links
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'attribute' + '/item-attribute-set-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'attribute' + '/item-attribute-set-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'attribute' + '/item-attribute-set-links';
    this.httpClient = http;
  }

  createLinksToUpdateChildItemsOfGroupedItems(dto: ItemAttributeSetLinkContainerModel[], visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/backoffice-ep/multi/update-child-items";
    }
    return this.httpClient.post(this.apiUrl, dto, this.getHttpHeaderJson(visa));
  }

  syncAttributeSetLinkToMarketplace(mktGuid: string, attSetLinks: string[], visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + `/backoffice-ep/${mktGuid}`;
    }
    return this.httpClient.post(this.apiUrl, attSetLinks, this.getHttpHeaderJson(visa))
  }
}
